import moment from "moment";
import CalendarEventRow from "./CalendarEventRow";
import "../gestio/table/CastellersTable.css";
import "./CalendarEventsTable.css";

function CalendarEventsTable({
    events,
    eventCategories,
    socket,
    eventsToBeDeleted,
    containerRef,
    onScroll,
    onRowRef,
    topSpacerHeight = 0,
    bottomSpacerHeight = 0,
    now,
}) {
    const deletedEventIds = new Set(eventsToBeDeleted || []);
    const nowMoment = moment(now);

    return (
        <div
            className="castellers-table-container calendar-events-table-container"
            data-testid="calendar-events-table-container"
            ref={containerRef}
            onScroll={onScroll}
        >
            <table className="castellers-table calendar-events-table">
                <colgroup>
                    <col style={{ width: '12%' }} />
                    <col style={{ width: '8%' }} />
                    <col style={{ width: '17%' }} />
                    <col style={{ width: '12%' }} />
                    <col style={{ width: '8%' }} />
                    <col style={{ width: '9%' }} />
                    <col style={{ width: '12%' }} />
                    <col style={{ width: '9%' }} />
                    <col style={{ width: '13%' }} />
                </colgroup>
                <thead>
                    <tr>
                        <th>Data</th>
                        <th>Hora</th>
                        <th>Títol</th>
                        <th>Lloc</th>
                        <th>Tipus</th>
                        <th>Categoria</th>
                        <th>Visibilitat</th>
                        <th>Assistència</th>
                        <th>Accions</th>
                    </tr>
                </thead>
                <tbody>
                    {topSpacerHeight > 0 ? (
                        <tr className="calendar-events-spacer-row" aria-hidden="true">
                            <td
                                className="calendar-events-spacer-cell"
                                colSpan={9}
                                style={{ height: topSpacerHeight }}
                            />
                        </tr>
                    ) : null}

                    {events.map(event => {
                        const toBeDeleted = deletedEventIds.has(event.id);
                        return (
                            <CalendarEventRow
                                key={event.id}
                                event={event}
                                eventCategories={eventCategories}
                                socket={socket}
                                toBeDeleted={toBeDeleted}
                                now={nowMoment}
                                onRowRef={onRowRef}
                            />
                        );
                    })}

                    {bottomSpacerHeight > 0 ? (
                        <tr className="calendar-events-spacer-row" aria-hidden="true">
                            <td
                                className="calendar-events-spacer-cell"
                                colSpan={9}
                                style={{ height: bottomSpacerHeight }}
                            />
                        </tr>
                    ) : null}
                </tbody>
            </table>
        </div>
    );
}

export default CalendarEventsTable;
